module.exports = __webpack_public_path__ + "img/20220312_144854.f4b94e5d.jpg";